import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../configurations/configuration';
import { environment } from '../../../environments/environment';
import { NotificationEvents } from '../../models/notifications/notifications';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  eventNotifications: string;
  constructor(private http: HttpClient) {
    this.eventNotifications = environment.baseURI + environment.apiUrl + 'events/getEventNotifications';
  }

  getEventNotifications(filterObj, limit, start): Observable<NotificationEvents> {
    return this.http.get<NotificationEvents>(this.eventNotifications + "?filter=" + encodeURIComponent(JSON.stringify(filterObj)) + "&limit=" + limit + "&start=" + start, httpOptions);
  }
}
